/** Extract backend error code from axios-style errors. */
export function getCommunityErrorCode(err: unknown): string | undefined {
  return (err as { response?: { data?: { error?: { code?: string } } } })?.response?.data?.error
    ?.code;
}

export function getCommunityErrorMessage(err: unknown, fallback: string): string {
  return (
    (err as { response?: { data?: { error?: { message?: string } } } })?.response?.data?.error
      ?.message || fallback
  );
}

/** User-facing copy for message send failures (incl. OpenAI content moderation). */
export function getCommunitySendFailureMessage(
  err: unknown,
  fallback = 'Failed to send message'
): string {
  const code = getCommunityErrorCode(err);
  if (code === 'CONTENT_BLOCKED') {
    return getCommunityErrorMessage(
      err,
      'This message was blocked by content moderation. Please revise and try again.'
    );
  }
  if (code === 'MODERATION_UNAVAILABLE') {
    return getCommunityErrorMessage(
      err,
      'Content moderation is temporarily unavailable. Please try again.'
    );
  }
  return getCommunityErrorMessage(err, fallback);
}
